// This file was automatically generated from app.onboarding.activateAccount.html.
// Please don't edit this file by hand.

goog.provide('el8.template.app.onboarding.activateAccount');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.onboarding.activateAccount.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div id="activate-account-container" class="overlayContainer"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.onboarding.activateAccount.freshContent = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8PromptDialogContainer"><p>Get simple, affordable pricing with the flexibility that suits your practice needs.</p><div class="el8Spacer"></div><div class="requestButtonContainer"><button type="button" class="newButton learn-more">Learn More</button></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.onboarding.activateAccount.successContent = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div><div class="el8Spacer"></div><div class="submitConfirmation">Thank you!</div><p>We\'ve received your request. A member of the Elation practice development team will contact you within the next business day to finalize your subscription.</p><p>In the meantime, feel free to watch these videos to help you get started:</p><ul><li class="el8BulletText el8ListStyleNone"><a target="_blank" rel="noopener" href="https://help.elationhealth.com/s/article/clinical-training-series---individual-videos">Getting Started as a Provider</a></li><li class="el8BulletText el8ListStyleNone"><a target="_blank" rel="noopener" href="https://help.elationhealth.com/s/article/administrative-training-series---individual-videos">Getting started as a Staff Member</a></li><div class="el8Spacer"></div></ul></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.onboarding.activateAccount.errorContent = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div><p>Sorry!  We were unable to submit your request. Please <a class="reset-form-trigger">try again</a>.</p><p class="el8AppText">If you continue to experience trouble, please give us a call directly at 1-888-974-5625, or <a href="https://help.elationhealth.com/s/contactsupport">contact us</a>.</p><button type="button" class="reset-form-trigger">Try again</button></div>');
  if (!opt_sb) return output.toString();
};
